/**
 * Shared layout constants and MyHeritage-inspired palette used by the
 * family-tree canvas and its sub-components. Extracted from
 * FamilyTreeDetail.jsx so individual card/drawer/search components can
 * live in their own files without a circular dependency.
 */

export const TREE_CARD_W = 116;
// Bumped Sep 2026 so a 3-line name (first/middle/family) fits alongside
// birthplace + current-location rows.
export const TREE_CARD_H = 188;
export const COUPLE_GAP = 14;    // horizontal gap between the two cards of a couple
export const SIBLING_GAP = 22;   // horizontal gap between neighboring units
export const GEN_GAP = 84;       // vertical space between rows of a generation
export const ROW_H = TREE_CARD_H + GEN_GAP;
export const H_PAD = 32;
export const V_PAD = 32;

/**
 * MyHeritage-inspired card palette — deep sepia name, copper italic
 * dates, gender-tinted ribbon, double-gold ring around the portrait
 * for an heirloom feel.
 */
export const HERITAGE_PALETTE = {
  ivory:         "#FEFCF7",
  border:        "rgba(160,124,60,0.35)",
  borderStrong:  "rgba(160,124,60,0.75)",
  ink:           "#3B2E1F",
  inkSoft:       "#6B5A3F",
  copper:        "#A8792C",
  ringOuter:     "#B58936",
  ringInner:     "#F0DFA6",
  ribbonMale:    "#DDEAF6",
  ribbonFemale:  "#F5D6DF",
  ribbonUnknown: "#F0E4C4",
  deceasedBg:    "#F5EFE3",
  deceasedInk:   "#5C4A2E",
};
